import React, { useEffect, useRef } from 'react';
import { AD_SRC, type AdSize } from './adUnits.ts';

type AffiliatedAdProps = {
  size: AdSize;
};

const AffiliatedAd: React.FC<AffiliatedAdProps> = ({ size }) => {
  const containerRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const script = document.createElement('script');
    script.src = AD_SRC[size];
    script.async = true;
    script.setAttribute('language', 'JavaScript1.1');
    container.appendChild(script);

    return () => {
      container.replaceChildren();
    };
  }, [size]);

  return <span ref={containerRef} />;
};

export default AffiliatedAd;
